import { createFileRoute } from '@tanstack/react-router'

import { DriveSetup } from '@/features/drives/drive-setup'
import { handoverGate } from '@/features/handover/gate'

/** The hand-over form, at `/bookings/{id}/drive`: the drive details that open the activity. */
export const Route = createFileRoute('/_app/bookings/$bookingId_/drive')({
  ...handoverGate(),
  component: DriveSetup,
})
